<template>
    <div class="py-4">
        <h3 class="pb-8 text-2xl">
            <span class="font-bold">Popular</span>
            {{ manufacturer.name }} models
        </h3>

        <div v-if="models.length > 0" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            <ModelCard v-for="model of models" :model="model" :manufacturer="manufacturer"></ModelCard>
        </div>

        <p v-else>
            We don't have any {{ manufacturer.name }} models associated with reviews on record.
        </p>
    </div>
</template>

<script>
import ModelCard from "@/Components/Models/ModelCard";

export default {
    components: {ModelCard},
    props: {
        manufacturer: Object,
        models: Array
    },

};
</script>

<style scoped>

</style>
